import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getOrderDocumentListData } from './mockData'
import type { IOrderDocument } from '~/types/document/models'

export const {
  getDocuments: getOrderDocuments,
  postDocument: postOrderDocument,
  patchDocument: patchOrderDocument,
  deleteDocument: deleteOrderDocument,
  handlers,
} = makeDocumentAPIs<IOrderDocument>({
  apiPathEntityNamePrefix: 'order',
  getDocumentListDataFn: getOrderDocumentListData,
})
